<template>
  <div id="documenten" class="justify-center">
    <ehr-navigation active-item="documenten"></ehr-navigation>
    <div class="container">
      <section-card card-title="Documenten" card-icon="file-alt">
        <template v-slot:extraHeaderContent>
          <span
            v-if="amountUploadsNeeded > 0"
            class="badge badge-primary ml-2 mt-2 float-right"
          >
            {{ amountUploadsNeeded }} uploads vereist
          </span>
          <span v-else class="badge badge-success ml-2 mt-2 float-right">
            Geen uploads vereist
          </span>
        </template>
        <div class="container d-flex flex-row justify-content-center mb-3">
          <div
            class="btn-group btn-group-toggle float-right"
            data-toggle="buttons"
          >
            <label class="btn btn-secondary active">
              <input
                @click="showAllDocuments = true"
                type="radio"
                name="options"
                id="option1"
                autocomplete="off"
                checked
              />
              Alle documenten
            </label>
            <label class="btn btn-secondary">
              <input
                @click="showAllDocuments = false"
                type="radio"
                name="options"
                id="option2"
                autocomplete="off"
              />
              Upload vereist
            </label>
          </div>
        </div>
        <div class="container">
          <transition-group
            name="list"
            tag="div"
            class="row text-center justify-content-center"
          >
            <document-block
              v-for="(document, index) in documentsToShow"
              class="list-item"
              :key="'document-block-' + index"
              :document-title="document.documentTitle"
              :description="document.description"
              :status="document.status"
            >
            </document-block>
          </transition-group>
        </div>
      </section-card>
    </div>
  </div>
</template>

<script>
import EhrNavigation from "./../interface/EhrNavigation.vue";
import SectionCard from "./../interface/SectionCard.vue";

import DocumentBlock from "./DocumentBlock.vue";
export default {
  name: "mijn-documenten",
  props: {
    placeholder: {
      type: String,
      required: false,
    },
  },
  components: {
    EhrNavigation,
    SectionCard,
    DocumentBlock,
  },
  data() {
    return {
      documents: [
        {
          documentTitle: "Ziektebrief",
          description:
            "Hier komt een beschrijving van het te uploaden document",
          status: "accepted",
        },
        {
          documentTitle: "Aanvraag ADG",
          description: "Beschrijving komt hier",
          status: "needs-upload",
        },
        {
          documentTitle: "Uittreksel geboorteakte",
          description: "Test",
          status: "accepted",
        },
        {
          documentTitle: "Definitief diploma",
          description: "Dit is een beschrijving van het document",
          status: "accepted",
        },
        {
          documentTitle: "Nationaliteitsbewijs",
          description: "Dit is een test document",
          status: "accepted",
        },
        {
          documentTitle: "Aanvraag ADG",
          description: "Beschrijving komt hier",
          status: "needs-upload",
        },
      ],
      showAllDocuments: true,
    };
  },
  computed: {
    amountUploadsNeeded() {
      return this.documents.filter((doc) => doc.status == "needs-upload")
        .length;
    },
    documentsToShow() {
      if (this.showAllDocuments) {
        return this.documents;
      } else {
        return this.documents.filter((doc) => doc.status == "needs-upload");
      }
    },
  },
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active .list-item {
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-move {
  transition: transform 0.5s;
}

.list-item {
  display: inline-block;
}

.list-leave-active {
  position: absolute;
}
</style>
